exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deliv-logo[data-v-5d91f44c]{display:flex}.deliv-logo span[data-v-5d91f44c]{color:#000}", ""]);

// exports
